// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_INSTRUCTORS,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getInstructors = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('instructors')
      .then(
        (response) => {
          dispatch(GET_INSTRUCTORS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/instructorsActions.js